<template>
  <div>
    <Menu mode="horizontal" :active-name="$route.name" @on-select="selectMenu">
      <span style="float: left">
        <a style="margin-left: 24px; margin-right: 24px;" v-on:click="$router.push({ name: 'server' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      </span>
      <MenuItem name="private_cloud_server_detail">
        基本信息
      </MenuItem>
      <!--<MenuItem name="2">-->
        <!--监控-->
      <!--</MenuItem>-->
      <MenuItem name="private_cloud_server_console">
        控制台
      </MenuItem>
      <MenuItem name="private_cloud_server_console_log">
        控制台日志
      </MenuItem>
      <MenuItem name="private_cloud_server_operate_log">
        操作日志
      </MenuItem>
    </Menu>
    <operateLog ref="operateLog" fixed-object="server" :fixed-object-id="$route.params.id" style="margin-top: 10px"></operateLog>
  </div>
</template>

<script>
import operateLog from '../operate-log/operate-log'

export default {
  name: 'server-operate-log',
  components: {
    operateLog
  },
  data () {
    return {

    }
  },
  methods: {
    selectMenu (name) {
      this.$router.push({name: name, params: { id: this.$route.params.id }})
    }
  }
}
</script>

<style scoped>

</style>
